import { openLink } from '../../utils/linkUtils';

export function OpenCalenderInvite(url) {
    openLink(url);
}
